import { Col, Row } from "antd";
import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { SubmitButton, TextComponent } from "../../../../components";
import styles from "./template.module.css";

import { useState } from "react";
import { PiDotsThreeOutlineFill } from "react-icons/pi";
import { RiDeleteBinLine } from "react-icons/ri";
import img3 from "../../../../assets/staticImages/templateImg.png";
import { Icons } from "./Icons";
import { selectIcon } from "../../../../components/icons/Icons";
import { useDispatch, useSelector } from "react-redux";
import { showAlert } from "../../../../Store/Actions/GeneralActions";
import { ClearRSVP } from "../../../../Store/Actions/EventPlanningActions";

function Template() {
  const { state } = useLocation();
  console.log("stateeeeeeeeee", state);
  const RSVP = useSelector((state) => state.EventPlanningReducer.RSVP);
  const [dropdownOpen, setDropdownOpen] = useState();
  const navigate = useNavigate();
  const [message, setMessage] = useState(RSVP?.invitation?.message);
  const dispatch = useDispatch();

  // useEffect(() => {
  //   if (RSVP?.event_id != state?.eventData?.id) {
  //     dispatch(ClearRSVP());
  //   }
  // }, []);

  const submit = () => {
    if (!message) {
      dispatch(
        showAlert({
          type: "Error",
          title: "Message",
          message: "Please add your message.!",
          status: 400,
        })
      );
    } else {
      navigate("/events/rsvp", {
        state: {
          headrTitle: "RSVP",
          data: {
            type: "message",
            message: message,
            eventData: state?.eventData,
          },
        },
      });
    }
  };
  return (
    <>
      <Row className={styles.container}>
        {/* {screenFrom == "Template" ? (
          <Col className={styles.imgContainer}>
            <Row className={styles.dotsCont}>
              <PiDotsThreeOutlineFill
                className={styles.dropdownBtn}
                onClick={(e) => {
                  e.stopPropagation();
                  setDropdownOpen(!dropdownOpen);
                }}
                size={35}
              />
            </Row>
            {dropdownOpen && (
              <Row className={styles.dropdown}>
                <Col>
                  <Row
                    className={styles.dropdownItem}
                    onClick={(e) => {
                      // deleteTemplate(item)
                      setDropdownOpen(!dropdownOpen);
                      navigate(-1);
                    }}
                  >
                    {selectIcon}
                    <TextComponent textClass={styles.dropdownText}>
                      Select Another Template
                    </TextComponent>
                  </Row>
                </Col>
              </Row>
            )}
            <img src={img3} className={styles.image} alt="template img" />
          </Col>
        ) : ( */}
        <Col className={styles.imgContainer}>
          {Icons}
          <Row>
            <TextComponent
              text="Send your requests for RSVPs"
              textClass={styles.heading}
            />
          </Row>
          <Row>
            <TextComponent
              text="1. Personalize your message"
              textClass={styles.subHead}
            />
          </Row>
          <Row className={styles.messageCont}>
            <Col style={{ width: "100%" }}>
              <Row>
                <TextComponent
                  text="Confirm your attendance"
                  textClass={styles.title}
                />
              </Row>
              <Row>
                <textarea
                  placeholder="You’re invited! Please RSVP to let us know if you’re able to attend."
                  className={styles.textArea}
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                />
              </Row>
            </Col>
          </Row>
        </Col>
        {/* )} */}
      </Row>
      <Row className={styles.btnCont}>
        <SubmitButton title="RSVP" btnClass={styles.saveBtn} onClick={submit} />
      </Row>
    </>
  );
}

export default Template;
